'use client';
import dynamic from 'next/dynamic';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import HireProcess from '@/components/technologies/hire-process';
import BasOffers from '@/components/technologies/bas-offer';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
import KEYBlue from '@/components/common/keylist-blue';
import Image from 'next/image';
import BusinessAnalysisServices from '@/components/technologies/business-analysis-services';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Whether you want to scale a successful business or you are an aspiring startup, our Business Analyst experts will help you define your business goals by leveraging an in-detailed blueprint of your software idea that would reduce the risk and bring you a step closer to your ultimate business goal."
                alt="hero image"
                title="hero image"
                width={1056}
                height={572}
                path={'ba-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Finding it hard to bridge the gap between an idea and its execution?
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="Business Analysis Service" />
            {/* enterprises start */}
            <section className="section-py case-study-main ">
                <div className="container lg:container md:mx-auto">
                    <div className="text-center mb-50">
                        <h2>Who needs Business Analysis Services (BAaaS)?</h2>
                    </div>
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12 bs-gy-10">
                        <div className="xl:col-span-6 lg:col-span-6 md:col-span-12 order-2 lg:order-1">
                            <div>
                                <h2 className="mb-5 fw-700 fs-xl">Small, Medium, and Large enterprises</h2>
                                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                    <KEYBlue text="We carry out digital transformation of your existing business to establish online footprints." />
                                    <KEYBlue text="We can perform an audit of your existing or legacy application" />
                                    <KEYBlue text="We can integrate new modules, systems, or infrastructure into your IT system." />
                                    <KEYBlue text="We advise new technology, trends, and techniques to enhance your system performance." />
                                </div>
                            </div>
                        </div>
                        <div className="xl:col-start-8 xl:col-span-5 lg:col-span-5 md:col-span-12 order-1 lg:order-2">
                            <div className="key-challenges-image text-center">
                                <Image
                                    src="/img/icons/ba-enterprise.svg"
                                    className="img-fluid"
                                    alt="enterprise"
                                    title="enterprise"
                                    height={605}
                                    width={515}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* enterprises end */}
            {/* entrepreneurs start */}
            <div className="section-py case-study-main  dark:text-light">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12 bs-gy-10">
                        <div className="xl:col-span-5 lg:col-span-5 md:col-span-12">
                            <div className="key-challenges-image text-center">
                                <Image
                                    src="/img/icons/ba-entrepreneurs.svg"
                                    className="img-fluid"
                                    alt="entrepreneurs"
                                    title="entrepreneurs"
                                    width={569}
                                    height={531}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        <div className="xl:col-span-6 xl:col-start-7 lg:col-span-6 md:col-span-12">
                            <div>
                                <h2 className="mb-5 fw-700 fs-xl">Start-ups, Aspiring entrepreneurs</h2>
                                <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                    <KEYBlue text="We conduct market and competitive analysis to evaluate your project scope." />
                                    <KEYBlue text="We highlight your application's USP and core features to develop its MVP version." />
                                    <KEYBlue text="We boost your project crowdfunding by helping you in the development of a pitch deck & funding documentation." />
                                    <KEYBlue text="We save a significant amount of your budget before the development stage." />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BusinessAnalysisServices title="Benefits of Having BA as a Service" />
            <BasOffers />
            <HireProcess
                white={true}
                bg="bg-primary"
                pageTitle="Hire Business Analyst To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Business Analysis."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For BAaaS Services?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Business Analyst"
                desc="Select from different engagement models to hire a Business Analyst for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
